import * as amplitudeAnalytics from '@amplitude/analytics-browser'

export function getSessionId(): number {
  return amplitudeAnalytics.getSessionId() || Date.now()
}
